import i18n from '@/plugins/i18n';
import utils from '@/utils/functions';
import moment from 'moment';

const staticData = () => {
  return {
    columns: [
      {
        key: 'affiliate_name',
        label: i18n.t('Affiliate')
      },
      {
        key: 'affiliate_token',
        label: 'Token'
      },
      {
        key: 'product_type_name',
        label: i18n.t('Product Type')
      },
      {
        key: 'transaction_date',
        label: i18n.t('Date'),
        formatter: (v) => moment.utc(v).format('DD/MM/YYYY')
      },
      {
        key: 'turnover',
        label: i18n.t('Turnover'),
        formatter: utils.formatMoneyFloat
      },
      {
        key: 'bonus',
        label: i18n.t('Bonus'),
        formatter: utils.formatMoneyFloat
      },
      {
        key: 'payout',
        label: i18n.t('Payout'),
        formatter: utils.formatMoneyFloat
      },
      {
        key: 'reward_percentage',
        label: i18n.t('Percentage')
      },
      {
        key: 'entry_value',
        label: i18n.t('Reward'),
        formatter: utils.formatMoneyFloat
      }
    ],
    columnsGames: [
      {
        key: 'gameId',
        label: 'Id'
      },
      {
        key: 'gameName',
        label: i18n.t('Name')
      },
      {
        key: 'turnover',
        label: i18n.t('Turnover'),
        formatter: utils.formatMoneyFloat
      },
      {
        key: 'payout',
        label: i18n.t('Payout'),
        formatter: utils.formatMoneyFloat
      }
    ]
  };
};

export default staticData;
